<template>
    <TheNotice></TheNotice>
    <div class="container-fluid">
        <div class="container">
            <form name="form">
                <div class="login-container row">
                    <div class="login-wrap card col-md-5 m-auto">
                        <div class="align-items-center py-5">
                            <div class="row">
                                <div class="col-md-9 mx-auto">
                                    <div class="login-content d-flex align-items-center justify-content-center">
                                        <img src="../assets/image/logo_login.png" style="height: inherit;">
                                    </div>
                                    <h3 class="text-center mb-4">BERJAYA FINANCE - RPK
										<br>
										<span class="text-center text-danger mb-3" v-if="envMode != null && envMode != ''">[{{envMode}}]</span>
									</h3>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col-md-9 mx-auto required">
                                    <InputText class="p-inputtext" type="text" maxlength="50" placeholder="Email Address" v-model="username"/>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col-md-9 mx-auto required">
                                    <InputText class="p-inputtext" type="password" maxlength="50" placeholder="Password" v-model="password"/>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col-md-9 d-flex mx-auto">
                                    <div class="col-md-12 d-grid shadow">
                                        <Button class="p-button-lg text-uppercase" @click="login" :disabled="v$.$invalid || isLoading" label="Sign in"/>
                                    </div>

                                    <TheLoading v-if="isLoading"></TheLoading>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="row col-md-9 mx-auto">
                                    <div class="col-md-6 ps-0 pe-0 login-remember-me">
                                        <Checkbox v-model="rememberMe" :binary="true"/>
                                        <span class="p-1"></span>
                                        <label for="binary">Keep Login (8HR)</label>
                                    </div>

                                    <div class="col-md-6 ps-0 pe-0">
                                        <Button class="p-button-link float-end pe-0" label="Forgot Password" @click="forgotPassword"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <TheFooter :hideCompany="true"></TheFooter>
                    </div>
                </div>
            </form>
        </div>
    </div>
    
    <Dialog header="Two Factor Authentication" v-model:visible="auth2FADialog.visible" :draggable="false" :style="{width:'30vw'}" @hide="cancelAuth2FA">
        <div class="border-top">
			<div v-if="auth2FADialog.auth2FADetail.result == 'enroll'">
				<div class="row">
					<div class="col-md-12">
						<div class="my-3"><b>Set up two-factor authentication.</b></div>
						
						<div class="my-2">
							<p>To be able to authorize transactions, you need to scan this QR Code with your Cisco Duo Authentication App and verify your identity.</p>
						</div>
					</div>
				</div>
				
				<div class="row">
					<div class="col-md-12">
						<div class="d-flex justify-content-center" style="border: 1px solid lightgrey">
							<img :src="auth2FADialog.auth2FADetail.activation_barcode" alt="activationCode" style="width:150px">
						</div>
					</div>
				</div>
				
				<div class="row">
					<div class="col-md-12 d-flex justify-content-center">
						<Button class="p-button-link float-end pe-0" label="Not yet registered? Click here" @click="enroll2FA(auth2FADialog.auth2FADetail.activation_url)"/>
					</div>
				</div>
			</div>
			
			<div v-else>
				<div class="row">
					<div class="col-md-12">
						<div class="my-3">
							<p>Please approve this login session with your Cisco Duo Authentication App on the registered device to verify your identity.</p>
						</div>
					</div>
					
					<TheLoading v-if="auth2FADialog.loading"></TheLoading>
					
					<div class="col-md-12" v-if="auth2FADialog.errorMessage != null">
						<div class="my-2">
							<InlineMessage severity="error">{{auth2FADialog.errorMessage}}</InlineMessage>
						</div>
					</div>
				</div>
			</div>
        </div>
    </Dialog>

</template>

<script lang="ts">
    import { defineComponent } from "vue";
	import { envMode } from "../../package.json";
	
    import {Md5} from "ts-md5";

	import cookieUtils from "@/mixin/utils/cookie-utils";

    import TheFooter from "@/components/TheFooter.vue";
	import TheLoading from "@/components/TheLoading.vue";
    import TheNotice from "@/components/TheNotice.vue";

    import { useVuelidate } from "@vuelidate/core";
    import { required, email } from "@vuelidate/validators";
    import loginApi from "@/api/login-api";

    export default defineComponent({
        mixins: [cookieUtils],
        components: {
			TheFooter,
            TheLoading,
            TheNotice,
        },
        data() {
            return {
				envMode: envMode,
                username: "",
                password: "",
                rememberMe: false,
                isLoading: false,
                auth2FADialog: {auth2FADetail: null as any, visible: false, loading: false, errorMessage: null as any},
                enrollInterval: 0,
                userId: "",
            }
        },
        created() {
            window.addEventListener("keypress", this.eventKeyPress);
        },
        beforeUnmount() {
            window.removeEventListener("keypress", this.eventKeyPress);
        },
        watch: {
            'auth2FADialog.loading': function (loading) {
                if (loading) {
					if (this.auth2FADialog.auth2FADetail != null && this.auth2FADialog.auth2FADetail['result'] != null && this.auth2FADialog.auth2FADetail['result'] == 'enroll') {
						this.enrollInterval = setInterval(this.checkAuthEnrollStatus, 3000);
					}
                }
                
                else {
					if (this.enrollInterval > 0) {
						clearInterval(this.enrollInterval);
					}
                }
            }
        },
        mounted() {
			document.body.classList.remove("dialog-open");
			
            var cookie = this.getCookie("RPK");
            if (cookie != null) {
                this.rememberMe = true;
            }
        },
        methods: {
            eventKeyPress: function (event: any) {
                if (event.key == "Enter") {
                    if (!(this.v$.$invalid || this.isLoading)) {
                        this.login();
                    }
                }
            },
            login() {
                this.isLoading = true;
                var user = {
                    username: this.username,
                    password: Md5.hashStr(this.password),
                    rememberMe: this.rememberMe
                }
                this.$store.dispatch("updateIsRememberMe", this.rememberMe)
                this.$store.dispatch("login", {user: user})
                    .then((response: any) => {
                        if (response.data.auth2fa == null) {
							this.setSessionCookie(response);
                            this.isLoading = false;
                            this.$router.push("/home");
                        }
                        
                        else {
							if (response.data.auth2fa.result == "enroll") {
								this.userId = response.data.employee.identifier;
								this.auth2FADialog.auth2FADetail = response.data.auth2fa;
								this.auth2FADialog.visible = true;
								this.auth2FADialog.loading = true;
								this.isLoading = false;
							}
							
							else if (response.data.auth2fa.result == "auth") {
								this.userId = response.data.employee.identifier;
								this.auth2FADialog.auth2FADetail = response.data.auth2fa;
								this.auth2FADialog.visible = true;
								this.auth2FADialog.loading = true;
								this.isLoading = false;
								
								this.sendPushAuth(user);
							}
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        this.password = "";
                        this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                    })
            },
            checkAuthEnrollStatus() {
				loginApi.checkAuthEnrollStatus({
					userId: this.userId,
					rememberMe: this.rememberMe,
						auth2fa: {
							user_id: this.auth2FADialog.auth2FADetail['user_id'],
							activation_code: this.auth2FADialog.auth2FADetail['activation_code']
						}
					})
					.then((response: any) => {
						if (response.data.auth2fa != null) {
							if (response.data.auth2fa.result == "success") {
								this.setSessionCookie(response);
								this.auth2FADialog.loading = false;
								this.auth2FADialog.visible = false;
								this.$router.push("/home");
							}
						}
					})
					.catch((error: any) => {
						console.log(error);
					})
            },
            sendPushAuth(user: any) {
				loginApi.sendPushAuth({userId: this.userId, rememberMe: this.rememberMe})
                    .then((response) => {
                        if (response.data.auth2fa != null) {
							if (response.data.auth2fa.result == "allow") {
								this.setSessionCookie(response);
								this.auth2FADialog.loading = false;
								this.auth2FADialog.visible = false;
                                this.$router.push("/home");
                            }
                        }
                    })
                    .catch((error) => {
						this.auth2FADialog.loading = false;
                        this.auth2FADialog.errorMessage = error;
                    })
            },
            forgotPassword() {
                this.$router.push("/forgotpassword");
            },
            setSessionCookie(response: any) {
                if (this.rememberMe) {
                    this.setCookie("RPK", this.username, 1);
                }
                
                else {
                    this.setCookie("RPK", null, -1);
                }
                this.$store.dispatch("loginSession", response);
            },
            enroll2FA(website: any) {
				window.open(website, '_blank');
            },
            cancelAuth2FA() {
                this.auth2FADialog = {auth2FADetail: null as any, visible: false, loading: false, errorMessage: null as any};
            },
        },
        setup() {
            return {v$: useVuelidate()}
        },
        validations() {
            return {
                username: {
                    required, email
                },
                password: {
                    required
                }
            }
        }
});
</script>